export default {
    noOptions: "Lista je prazna.",
    noResult: "Elementi nisu pronađeni. Promijeni parametre pretrage.",
    placeholder: "Odaberi opciju",
    tagPlaceholder: "Pritisni enter za novi unos",
    selectLabel: "Pritisni enter da izabereš",
    selectGroupLabel: "Press enter to select group",
    selectedLabel: "Izabrano",
    deselectLabel: "Pritisni enter da ukloniš",
    deselectGroupLabel: "Pritisni enter da ukloniš grupe",
}
